﻿package org.example.project.screens_sys

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import kotlinx.coroutines.launch
import org.example.project.enginetabular.TabularScreen
import org.example.project.service.ZustandManager
import org.example.project.utils.All

@Composable
fun Firmenregister() {
    val tabularScreenKey = "Firmenregister"
    var eintraege by remember { mutableStateOf<List<All>>(emptyList()) }
    var letzteFilter by remember { mutableStateOf<Map<String, String>?>(null) }
    val scope = rememberCoroutineScope()
    fun checkboxText(value: Boolean?): String = if (value == true) "\u2705" else "\u2b1c"
    fun netzwerkAktiv(eintrag: All): Boolean = if (eintrag.istkunde) eintrag.snapNetzwerkfunktionen else eintrag.istnetzwerk
    fun firmenregisterZustand(eintrag: All): Int = when {
        eintrag.gesperrt == true -> ZustandManager.Firmenregister.GESPERRT
        eintrag.zustand == ZustandManager.Firmenregister.IN_FREISCHALTUNG -> ZustandManager.Firmenregister.IN_FREISCHALTUNG
        eintrag.zustand == ZustandManager.Firmenregister.IN_VERIFIZIERUNG -> ZustandManager.Firmenregister.IN_VERIFIZIERUNG
        eintrag.zustand == ZustandManager.Firmenregister.GESPERRT -> ZustandManager.Firmenregister.GESPERRT
        else -> ZustandManager.Firmenregister.VERIFIZIERT
    }
    suspend fun reloadFirmenregister() {
        eintraege = letzteFilter?.let { FirmenregisterApi.searchCompanies(it) }.orEmpty()
     .sortedWith(
    compareBy<All> { it.firma.orEmpty().lowercase() }
        .thenBy { it.plz }
        .thenBy { it.strasse }
        .thenBy { it.hausnummer }
)
    }

    val headers = listOf(
        "Firmen-ID",
        "SnapKey",
        "Position",
        "Firma",
        "Straße",
        "Hausnummer",
        "PLZ",
        "Ort",
        "Land",
        "Netzwerk",
        "Kunde",
        "Zustand"
    )

    TabularScreen(
                screenKey = tabularScreenKey,
                rollenKey = "Firmenregister",
                title = "Firmenregister",
                headers = headers,
                models = eintraege,
                data = eintraege.map { eintrag ->
                    (eintrag.firmenId.ifBlank { eintrag.firma }) to listOf(
                        eintrag.firmenId,
                        eintrag.snapKey,
                        eintrag.position,
                        eintrag.firma,
                        eintrag.strasse,
                        eintrag.hausnummer,
                        eintrag.plz,
                        eintrag.ort,
                        eintrag.land,
                        checkboxText(netzwerkAktiv(eintrag)),
                        checkboxText(eintrag.istkunde),
                        ZustandManager.Firmenregister.textFor(firmenregisterZustand(eintrag))
                    )
                },
                editable = true,
                useUserSettings = false,
                nonEditableCols = setOf("Firmen-ID", "SnapKey", "Position", "Netzwerk", "Kunde", "Zustand"),
                createRow = { _ ->
                    listOf("", "", "", "", "", "", "", "", "de", "\u2b1c", "\u2b1c", ZustandManager.Firmenregister.textFor(ZustandManager.Firmenregister.IN_FREISCHALTUNG))
                },
                allowCreate = true,
                allowDelete = false,
                onRefresh = {
                    scope.launch {
                        runCatching { reloadFirmenregister() }
                    }
                },
                onSearchWithFilters = { filters ->
                    scope.launch {
                        letzteFilter = filters
                        reloadFirmenregister()
                    }
                },
                onCommit = { rows ->
                    scope.launch {
                        rows.forEach { (rowId, cols) ->
                            val firma = cols.getOrNull(3).orEmpty().trim()
                            val strasse = cols.getOrNull(4).orEmpty().trim()
                            val hausnummer = cols.getOrNull(5).orEmpty().trim()
                            val plz = cols.getOrNull(6).orEmpty().trim()
                            val ort = cols.getOrNull(7).orEmpty().trim()
                            if (firma.isBlank() || strasse.isBlank() || hausnummer.isBlank() || plz.isBlank() || ort.isBlank()) {
                                return@forEach
                            }

                            val existing = eintraege.firstOrNull {
                                it.firmenId == rowId || it.firma == rowId
                            }

                            val registerEintrag = (existing ?: All()).copy(
                                id = cols.getOrNull(0).orEmpty().trim().ifBlank { existing?.id.orEmpty() },
                                firmenId = cols.getOrNull(0).orEmpty().trim().ifBlank { existing?.firmenId.orEmpty() },
                                snapKey = cols.getOrNull(1).orEmpty().trim().ifBlank { existing?.snapKey.orEmpty() },
                                position = cols.getOrNull(2).orEmpty().trim(),
                                firma = firma,
                                strasse = strasse,
                                hausnummer = hausnummer,
                                plz = plz,
                                ort = ort,
                                land = cols.getOrNull(8).orEmpty().trim().ifBlank { existing?.land ?: "de" },
                                snapNetzwerkfunktionen = existing?.snapNetzwerkfunktionen ?: false,
                                istnetzwerk = existing?.istnetzwerk ?: false,
                                istkunde = existing?.istkunde ?: false,
                                gesperrt = existing?.gesperrt ?: false,
                                zustand = existing?.zustand ?: ZustandManager.Firmenregister.VERIFIZIERT
                            )

                            FirmenregisterApi.saveCompany(registerEintrag)
                        }

                        reloadFirmenregister()
                    }
                },
                approveButtonLabel = "Zugang verifizieren",
                onApproveSelected = { selected ->
                    scope.launch {
                        selected.forEach { id ->
                            val eintrag = eintraege.firstOrNull { it.firmenId == id || it.id == id || it.firma == id } ?: return@forEach
                            FirmenregisterApi.saveCompany(
                                eintrag.copy(
                                    aktiv = false,
                                    gesperrt = false,
                                    zustand = ZustandManager.Firmenregister.IN_VERIFIZIERUNG
                                )
                            )
                        }
                        reloadFirmenregister()
                    }
                },
                cancelButtonLabel = "Zugang sperren",
                onCancelRows = { selected ->
                    scope.launch {
                        selected.forEach { id ->
                            val eintrag = eintraege.firstOrNull { it.firmenId == id || it.id == id || it.firma == id } ?: return@forEach
                            FirmenregisterApi.saveCompany(
                                eintrag.copy(
                                    aktiv = false,
                                    gesperrt = true,
                                    zustand = ZustandManager.Firmenregister.GESPERRT
                                )
                            )
                        }
                        reloadFirmenregister()
                    }
                }
            )
}
